export const ACCESSIBILITY_LABELS = {
  removeFilter: (name: string) => `Verwijder filter: ${name}`,
  fromPrice: 'prijs vanaf',
  toPrice: 'prijs tot',
  allMedia: 'Alle media',
  filtersAndCategories: 'Filters en categorieën',
  productResults: 'Resultatenlijst',
  skipToMainContent: 'Ga naar hoofdinhoud',
  skipToFilters: 'Ga naar filters',
  productGalleryImage: (text: string) => `Open modal en vergroot ${text}`,
  productModalThumbnail: (text: string, index: number, totalImages: number) =>
    `Selecteer afbeelding ${index + 1} van ${totalImages}: ${text}`,
};
